// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Country\ApiCountry.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// CountryData is the class that Country serializes to/from
export interface CountryData {
    Id : number;
    Url : string | null;
	
	
    Code : string;
    IsoAlpha3Code : string;
    IsoNumericCode : string;
    Name : string;
    SortOrder : number;
}

// CountryOptions is the class which may be passed to the Country constructor to define optional initial data values
export interface CountryOptions {
    Id : number;
    Url? : string | null;
	
	
    Code? : string;
    IsoAlpha3Code? : string;
    IsoNumericCode? : string;
    Name? : string;
    SortOrder? : number;
}

export class Country {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
	
    public Code : DataSignal<string>;
    public IsoAlpha3Code : DataSignal<string>;
    public IsoNumericCode : DataSignal<string>;
    public Name : DataSignal<string>;
    public SortOrder : DataSignal<number>;

    constructor();
    constructor(data : CountryOptions);
    constructor(data: CountryOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
	    
        this.Code = jsonableObservable(S.value<string>(data && data.Code !== undefined ? data.Code : ''));
        this.IsoAlpha3Code = jsonableObservable(S.value<string>(data && data.IsoAlpha3Code !== undefined ? data.IsoAlpha3Code : ''));
        this.IsoNumericCode = jsonableObservable(S.value<string>(data && data.IsoNumericCode !== undefined ? data.IsoNumericCode : ''));
        this.Name = jsonableObservable(S.value<string>(data && data.Name !== undefined ? data.Name : ''));
        this.SortOrder = jsonableObservable(S.value<number>(data && data.SortOrder !== undefined ? data.SortOrder : 0));
    }

    static key(obj : Country) {
        return obj.Id();
    }
    
    static dataKey(obj : CountryOptions) {
        return obj.Id;
    }

    static update(obj : Country, data : CountryOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
	        
            if (data.Code !== undefined) obj.Code(data.Code);
            if (data.IsoAlpha3Code !== undefined) obj.IsoAlpha3Code(data.IsoAlpha3Code);
            if (data.IsoNumericCode !== undefined) obj.IsoNumericCode(data.IsoNumericCode);
            if (data.Name !== undefined) obj.Name(data.Name);
            if (data.SortOrder !== undefined) obj.SortOrder(data.SortOrder);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/Country.ts